import React from 'react';
import { useDispatch } from 'react-redux';

import { Page } from 'ui/components';

import { Report, Customer } from 'services/action';
import {
  Action,
  Table,
  Detail
} from './component';

const initialState = {
  customer: null,
  isLoading: false,
  data: null
};

const ReportAgingScreen = ({ match, location}) => {
  const Dispatch = useDispatch();
  const [{ data, customer }, setState, ] = React.useState(initialState);
  const paramType = new URLSearchParams(location?.search).get('type');

  const $customerLoad = async () => {
    const result = await Dispatch(Customer.$show(match?.params?.id))
    if (result?.message === 'success') {
      $onLoad(result?.data)
    }
  }

  const $onLoad = async(cus) => {
    let data = null
    const result = await Dispatch(Report.$agingCustomer(cus?.id, {type: paramType}));
    if (result?.message === 'success') {
      data = result?.data
    }

    setState((prevState) => ({ ...prevState, customer: cus, data: data }));
  }

  React.useEffect(() => {
    $customerLoad();
  }, [match]);

  return (
    <Page className="col-lg-11 col-md-11 bordered">
      <Page.Header
        title="Aging Customer Outstanding"
        pretitle="Detail"
        backTo="/report/outstanding"
      >
        <Action customer={customer} type={paramType} />
      </Page.Header>

      <Page.Body className="bg-white border-top padding mt-3 mt-md-0">
        <Detail customer={customer} data={data} />
        <Table data={data}/>
      </Page.Body>
    </Page>
  );
};

export default ReportAgingScreen;
